module.exports = __webpack_public_path__ + "img/Icon awesome-twitter.8253daf3.svg";